import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "../components/common/DataTable";
import api from "../services/api";
import { showToast, confirmDelete } from "../helper/notifications"; // UPDATED IMPORTS
import { useDebounce } from "../hook/useDebounce";

const UsersPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  
  /* ===== Sorting State ===== */
  const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });
  
  const debouncedSearch = useDebounce(search, 500);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/users", { 
        params: { 
          search: debouncedSearch,
          sort_by: sortConfig.key,
          order: sortConfig.direction
        } 
      });
      setData(Array.isArray(res.data) ? res.data : res.data.users || []);
    } catch {
      // UPDATED: Use showToast for error
      showToast("error", "Failed to load users");
    } finally {
      setLoading(false);
    }
  }, [debouncedSearch, sortConfig]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleDelete = (row) => {
    // REPLACED: window.confirm with confirmDelete helper
    confirmDelete(row.email, async () => {
      try {
        await api.delete(`/users/${row.id}`);
        showToast("success", "Access revoked successfully"); // UPDATED
        fetchUsers();
      } catch (error) {
        showToast("error", "Failed to revoke access"); // UPDATED
      }
    });
  };

  return (
    <DataTable
      title="Authorized Users"
      subtitle="Manage administrator and editor access permissions."
      data={data}
      loading={loading}
      searchTerm={search}
      onSearchChange={setSearch}
      pagination={false}
      showCheckbox={false} 
      
      sortConfig={sortConfig}
      onSortChange={setSortConfig}

      headerActions={[
        {
          label: "Authorize Email",
          className: "btn btn-primary-600 radius-8 px-20 py-11 d-flex align-items-center gap-2",
          icon: "ri-add-line",
          onClick: () => navigate("/users/authorize"),
        },
      ]}
      columns={[
        { 
          key: "name", 
          label: "Name", 
          className: "text-md fw-semibold text-primary-light",
          sortable: true
        },
        { 
          key: "email", 
          label: "Google Account", 
          className: "text-secondary-light fw-medium",
          sortable: true 
        },
        { 
          key: "role", 
          label: "Role",
          sortable: true,
          render: (row) => (
            <span className={`badge px-24 py-4 radius-4 fw-medium text-sm ${
              row.role === 'ADMIN' ? 'bg-success-focus text-success-main' : 'bg-info-focus text-info-main'
            }`}>
              {row.role || 'USER'}
            </span>
          )
        },
      ]}
      actions={[
        {
          icon: "mingcute:delete-2-line",
          className: "w-32-px h-32-px bg-danger-focus text-danger-main rounded d-flex align-items-center justify-content-center border-0",
          onClick: handleDelete,
        },
      ]}
    />
  );
};

export default UsersPage;